import { render, staticRenderFns } from "./VerifyMobilephone.vue?vue&type=template&id=5f5294c2&scoped=true"
import script from "./VerifyMobilephone.vue?vue&type=script&lang=ts"
export * from "./VerifyMobilephone.vue?vue&type=script&lang=ts"
import style0 from "./VerifyMobilephone.vue?vue&type=style&index=0&id=5f5294c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5294c2",
  null
  
)

export default component.exports